export const comicList = [
  {
    id: 1,
    title: '女神降临',
    slug: 'goddess-descends',
    author: '喵喵',
    category: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20young%20woman%20with%20long%20dark%20hair%20and%20warm%20smile%2C%20soft%20pastel%20background%20with%20cherry%20blossoms%2C%20romance%20webtoon%20cover%20art%20style%2C%20clean%20composition%2C%20warm%20lighting%2C%20delicate%20facial%20features%2C%20cute%20aesthetic&width=800&height=1100&seq=comic-cover-01&orientation=portrait',
    description: '外貌平凡的女孩通过化妆技巧变身校园女神，却陷入了一场意想不到的三角恋。',
    chapters: 186,
    status: '已完结',
    rating: 9.5,
    views: 12800000,
    tags: ['恋爱', '校园', '逆袭'],
    featured: true,
    updatedAt: '2026-07-01',
  },
  {
    id: 2,
    title: '我独自升级',
    slug: 'solo-leveling',
    author: 'Chugong',
    category: '动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20illustration%20of%20a%20powerful%20hunter%20with%20dark%20clothing%20and%20glowing%20eyes%2C%20dark%20purple%20and%20black%20atmosphere%2C%20dungeon%20background%20with%20magical%20effects%2C%20intense%20fighting%20pose%2C%20webtoon%20action%20cover%20art%20style%2C%20dramatic%20lighting%2C%20cool%20aesthetic&width=800&height=1100&seq=comic-cover-02&orientation=portrait',
    description: '被称为人类最弱兵器的成振宇，在获得神秘系统后，开始了独自升级的传奇之路。',
    chapters: 200,
    status: '已完结',
    rating: 9.8,
    views: 35600000,
    tags: ['动作', '奇幻', '系统'],
    featured: true,
    updatedAt: '2026-06-28',
  },
  {
    id: 3,
    title: '公爵的契约未婚妻',
    slug: 'duke-contract-fiancee',
    author: 'Milcha',
    category: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20fantasy%20illustration%20of%20an%20elegant%20noblewoman%20in%20a%20beautiful%20Victorian%20dress%20with%20silver%20hair%2C%20luxurious%20palace%20interior%20background%2C%20soft%20warm%20golden%20lighting%2C%20romantic%20webtoon%20cover%20art%20style%2C%20refined%20aristocratic%20aesthetic&width=800&height=1100&seq=comic-cover-03&orientation=portrait',
    description: '穿越成小说中的配角，为了生存她与冷酷公爵签订了契约婚约，却不知命运正在悄然改变。',
    chapters: 152,
    status: '连载中',
    rating: 9.3,
    views: 8900000,
    tags: ['恋爱', '奇幻', '穿越'],
    featured: true,
    updatedAt: '2026-07-02',
  },
  {
    id: 4,
    title: '剑尊归来',
    slug: 'sword-master-returns',
    author: 'LEE Hyeon-min',
    category: '动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20illustration%20of%20a%20swordsman%20in%20traditional%20hanbok%20holding%20a%20glowing%20sword%2C%20ancient%20Korean%20palace%20courtyard%20background%2C%20dramatic%20moonlight%20scene%2C%20action%20webtoon%20cover%20art%20style%2C%20powerful%20aura%20effects%2C%20epic%20composition&width=800&height=1100&seq=comic-cover-04&orientation=portrait',
    description: '一代剑尊重生归来，这一次他不再为他人而战，只为守护自己珍视的一切。',
    chapters: 168,
    status: '连载中',
    rating: 9.6,
    views: 21500000,
    tags: ['动作', '武侠', '重生'],
    featured: true,
    updatedAt: '2026-07-03',
  },
  {
    id: 5,
    title: '金秘书为何那样',
    slug: 'whats-wrong-with-secretary-kim',
    author: 'Jung Kyung-yoon',
    category: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20illustration%20of%20a%20confident%20female%20secretary%20in%20elegant%20business%20attire%2C%20modern%20office%20background%20with%20warm%20sunlight%20through%20windows%2C%20romantic%20comedy%20webtoon%20cover%20art%20style%2C%20professional%20yet%20charming%20aesthetic%2C%20soft%20color%20palette&width=800&height=1100&seq=comic-cover-05&orientation=portrait',
    description: '完美秘书突然提出辞职，自恋副会长才发现自己早已离不开她。一段爆笑的办公室恋情。',
    chapters: 98,
    status: '已完结',
    rating: 9.2,
    views: 6700000,
    tags: ['恋爱', '职场', '喜剧'],
    featured: false,
    updatedAt: '2026-06-25',
  },
  {
    id: 6,
    title: '全知读者视角',
    slug: 'omniscient-reader',
    author: 'sing N song',
    category: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20a%20man%20reading%20a%20glowing%20book%20with%20mysterious%20symbols%2C%20apocalyptic%20cityscape%20background%20with%20monsters%20in%20distance%2C%20dramatic%20orange%20and%20dark%20blue%20sky%2C%20webtoon%20fantasy%20cover%20art%20style%2C%20epic%20composition&width=800&height=1100&seq=comic-cover-06&orientation=portrait',
    description: '唯一读完一部末世小说的读者，在小说成为现实的瞬间，拥有了预知一切的能力。',
    chapters: 210,
    status: '连载中',
    rating: 9.9,
    views: 42000000,
    tags: ['奇幻', '末世', '系统'],
    featured: true,
    updatedAt: '2026-07-02',
  },
  {
    id: 7,
    title: '某天成为公主',
    slug: 'who-made-me-a-princess',
    author: 'Plutus',
    category: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20a%20cute%20young%20princess%20with%20blonde%20hair%20and%20sparkling%20blue%20eyes%2C%20wearing%20an%20elegant%20pink%20dress%2C%20royal%20palace%20background%20with%20roses%2C%20fairy%20tale%20webtoon%20cover%20art%20style%2C%20dreamy%20atmosphere%2C%20soft%20magical%20glow&width=800&height=1100&seq=comic-cover-07&orientation=portrait',
    description: '穿越成注定被亲生父亲杀害的公主，为了活下去，她必须赢得冷酷父皇的心。',
    chapters: 125,
    status: '已完结',
    rating: 9.4,
    views: 15600000,
    tags: ['奇幻', '穿越', '亲情'],
    featured: false,
    updatedAt: '2026-05-30',
  },
  {
    id: 8,
    title: '重生之都市修仙',
    slug: 'rebirth-urban-cultivator',
    author: 'KIM Hyun-soo',
    category: '动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20urban%20fantasy%20illustration%20of%20a%20young%20man%20in%20modern%20clothing%20surrounded%20by%20energy%20aura%2C%20city%20skyline%20at%20night%20with%20neon%20lights%20background%2C%20cultivation%20webtoon%20cover%20art%20style%2C%20cool%20modern%20aesthetic%2C%20powerful%20stance&width=800&height=1100&seq=comic-cover-08&orientation=portrait',
    description: '修仙界大能重生回到都市，这一世他要弥补所有遗憾，踏上无上巅峰。',
    chapters: 245,
    status: '连载中',
    rating: 9.1,
    views: 18900000,
    tags: ['动作', '都市', '重生'],
    featured: false,
    updatedAt: '2026-07-01',
  },
  {
    id: 9,
    title: '她的私生活',
    slug: 'her-private-life',
    author: 'KIM Sung-yeon',
    category: '恋爱',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20of%20a%20professional%20woman%20with%20a%20secret%20fangirl%20side%2C%20holding%20a%20camera%2C%20art%20gallery%20background%20with%20paintings%2C%20warm%20sunlight%2C%20romantic%20comedy%20webtoon%20cover%20art%20style%2C%20charming%20dual%20life%20aesthetic&width=800&height=1100&seq=comic-cover-09&orientation=portrait',
    description: '美术馆首席策展人白天是职场精英，晚上却是狂热追星族。当新馆长发现她的秘密后，一切都变了。',
    chapters: 82,
    status: '已完结',
    rating: 8.9,
    views: 5400000,
    tags: ['恋爱', '职场', '喜剧'],
    featured: false,
    updatedAt: '2026-06-15',
  },
  {
    id: 10,
    title: '急诊室的故事',
    slug: 'er-stories',
    author: 'PARK Min-ji',
    category: '悬疑',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20medical%20thriller%20illustration%20of%20a%20doctor%20in%20white%20coat%20in%20an%20emergency%20room%2C%20dramatic%20hospital%20lighting%2C%20tense%20atmosphere%2C%20medical%20webtoon%20cover%20art%20style%2C%20professional%20yet%20suspenseful%20composition%2C%20cool%20blue%20tones&width=800&height=1100&seq=comic-cover-10&orientation=portrait',
    description: '顶尖急诊科医生在面对一系列离奇病例时，发现背后隐藏着不为人知的真相。',
    chapters: 134,
    status: '连载中',
    rating: 9.0,
    views: 7800000,
    tags: ['悬疑', '医疗', '剧情'],
    featured: false,
    updatedAt: '2026-06-30',
  },
  {
    id: 11,
    title: '反派千金的生存法则',
    slug: 'villainess-survival',
    author: 'HAN Seo-yeon',
    category: '奇幻',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20villainess%20illustration%20of%20a%20noble%20lady%20with%20dark%20red%20hair%20and%20determined%20expression%2C%20luxurious%20ballroom%20background%20with%20chandeliers%2C%20dramatic%20lighting%2C%20otome%20game%20webtoon%20cover%20art%20style%2C%20elegant%20yet%20intense%20aesthetic&width=800&height=1100&seq=comic-cover-11&orientation=portrait',
    description: '穿越进乙女游戏成为反派千金，为了逃离死亡结局，她开始改写自己的命运。',
    chapters: 178,
    status: '连载中',
    rating: 9.5,
    views: 23400000,
    tags: ['奇幻', '穿越', '女强'],
    featured: false,
    updatedAt: '2026-07-03',
  },
  {
    id: 12,
    title: '甜蜜的陷阱',
    slug: 'sweet-trap',
    author: 'LEE Da-hye',
    category: '悬疑',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20psychological%20thriller%20illustration%20of%20a%20woman%20with%20mysterious%20smile%20half%20in%20shadow%2C%20dark%20alley%20background%20with%20streetlamp%2C%20suspenseful%20webtoon%20cover%20art%20style%2C%20noir%20aesthetic%2C%20high%20contrast%20lighting&width=800&height=1100&seq=comic-cover-12&orientation=portrait',
    description: '一个看似完美的婚姻背后隐藏着令人窒息的秘密，她必须揭开真相才能活下去。',
    chapters: 96,
    status: '已完结',
    rating: 9.3,
    views: 11200000,
    tags: ['悬疑', '婚姻', '剧情'],
    featured: false,
    updatedAt: '2026-06-20',
  },
];

export const featuredComics = comicList.filter((c) => c.featured);

export const latestComics = [...comicList].sort(
  (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
);